<div
  class="footer"
  [class.footer__using-capacitor]="usingCapacitor">
  <div class="footer__header">
    <img
      alt="sharry logo"
      height="55"
      loading="eager"
      src="https://media.sharry.land/app/images/logo-SL-payoff.svg"
      width="180"
      [routerLink]="'explore' | routeTranslate" />
    <button
      class="sharry-small footer__body__language"
      style="margin-bottom: 0.5rem"
      (click)="onLanguageChange()">
      <sharry-icon name="globe"></sharry-icon>
      {{ language$ | async | language }}
    </button>
  </div>
  <div class="divider"></div>
  @if (showFooterContents()) {
    <div class="footer__body is-not-mobile">
      <div class="footer__body__column">
        <h4>{{ 'footer.subtitle-1' | i18nextEager }}</h4>
        <a
          class="footer__body__column--links"
          routerLink="{{ 'what-is-sharryland' | routeTranslate }}"
          >{{ 'footer.sharryland.what' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          href="https://info.sharry.land/guida/chisiamo.html"
          target="_blank"
          >{{ 'footer.sharryland.who' | i18nextEager }}</a
        ><!--routerLink="{{ 'who-we-are' | routeTranslate }}"-->
        <a
          class="footer__body__column--links"
          href="https://info.sharry.land/guida/valori.html"
          target="_blank"
          >{{ 'footer.sharryland.values' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          href="https://info.sharry.land/it/press.html"
          target="_blank"
          >{{ 'footer.sharryland.press' | i18nextEager }}</a
        >
        <!--      <a
          class="footer__body__column&#45;&#45;links"
          href="https://info.sharry.land/guida/coordinatore-viaggi.html"
          target="_blank"
          >{{ 'footer.become-coordinator' | i18nextEager }}</a
        >-->
        <a
          class="footer__body__column--links"
          href="https://info.sharry.land/guida/referente-territoriale.html"
          target="_blank"
          >{{ 'footer.partner.ref' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          href="https://info.sharry.land/guida/job.html"
          target="_blank"
          >{{ 'footer.sharryland.work' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'contacts' | routeTranslate }}"
          >{{ 'footer.contacts' | i18nextEager }}</a
        >
      </div>
      <div class="footer__body__column">
        <h4>{{ 'footer.solutions' | i18nextEager }}</h4>
        <a
          class="footer__body__column--links"
          routerLink="{{ 'wonders-map' | routeTranslate }}"
          >{{ 'footer.what-it-does' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'become-pro' | routeTranslate }}"
          >{{ 'footer.pro' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          href="https://info.sharry.land"
          target="_blank"
          >{{ 'footer.sharryland.pro-guide' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'faq' | routeTranslate }}"
          >{{ 'footer.faq' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          (click)="openSupportDialog()"
          >{{ 'profile-home.bottom-settings.speak-us' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'terms' | routeTranslate }}"
          >{{ 'footer.info.terms' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'selling-conditions' | routeTranslate }}"
          >{{ 'footer.info.selling-conditions' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'privacy' | routeTranslate }}"
          >{{ 'footer.info.privacy' | i18nextEager }}</a
        >
        <!--     <a
          class="footer__body__column&#45;&#45;links"
          role="button"
          (click)="onCookieClick()">
          Cookie
        </a>-->
      </div>
      <div class="footer__body__column">
        <h4>{{ 'footer.what-to-do-at' | i18nextEager }}</h4>
        <a
          class="footer__body__column--links"
          routerLink="{{ 'land' | routeTranslate }}"
          >{{ 'footer.lands' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'find/what-to-do-near' | routeTranslate }}"
          >{{ 'footer.find.what-to-do-near' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'find/what-to-do-at' | routeTranslate }}"
          >{{ 'footer.find.what-to-do-at' | i18nextEager }}</a
        >
        <a
          class="footer__body__column--links"
          routerLink="{{ 'find/what-to-do-in' | routeTranslate }}"
          >{{ 'footer.find.what-to-do-in' | i18nextEager }}</a
        >
      </div>
      <div class="footer__body__column">
        <!--
        <h4>{{ 'footer.subtitle-4' | i18nextEager }}</h4>
  -->
        <div
          class="footer__body__column--buttons"
          style="gap: 0.5rem; padding-top: 0.5rem">
          <a
            class="sharry-medium buttons"
            href="https://play.google.com/store/apps/details?id=sharry.land.app"
            rel="noopener"
            target="_blank">
            <sharry-icon
              name="google-play-fill"
              svgClass="svg-icon"
              type="custom"></sharry-icon
            >&nbsp;Google Play
          </a>
          <a
            class="sharry-medium buttons"
            href="https://apps.apple.com/it/app/sharryland/id1477462434"
            rel="noopener"
            style="margin-bottom: 1rem"
            target="_blank">
            <sharry-icon
              name="apple-fill"
              svgClass="svg-icon"
              type="custom"></sharry-icon
            >&nbsp;App Store
          </a>
        </div>
        <div class="footer__header__icons">
          <a
            href="https://www.facebook.com/Sharryland-1799581330057759/"
            rel="noopener"
            target="_blank">
            <sharry-icon
              class="svg-icon-container"
              registryName="facebook-logo"
              svgClass="svg-icon"></sharry-icon>
          </a>
          <a
            href="https://www.instagram.com/sharry.land/"
            rel="noopener"
            target="_blank">
            <sharry-icon
              class="svg-icon-container"
              registryName="instagram-logo"
              svgClass="svg-icon instagram"></sharry-icon>
          </a>
          <a
            href="https://www.linkedin.com/company/sharryland"
            rel="noopener"
            target="_blank">
            <sharry-icon
              class="svg-icon-container"
              registryName="linkedin-logo"
              svgClass="svg-icon linkedin"></sharry-icon>
          </a>
          <a
            href="https://www.youtube.com/channel/UCdFDSMMa1CDj7wsqy3aMU5w"
            rel="noopener"
            target="_blank"
            ><sharry-icon
              class="svg-icon-container"
              registryName="youtube-logo"
              svgClass="svg-icon youtube"></sharry-icon
          ></a>
        </div>
      </div>
    </div>
  }
  <div class="footer__body-mobile is-mobile">
    <mat-accordion
      displayMode="flat"
      [multi]="false"
      (click)="$event.stopImmediatePropagation(); $event.stopPropagation()">
      <mat-expansion-panel class="sharry-flat-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'footer.subtitle-1' | i18nextEager }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-panel-body">
          <a
            class="footer__body__column--links"
            routerLink="{{ 'what-is-sharryland' | routeTranslate }}"
            >{{ 'footer.sharryland.what' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/guida/chisiamo.html"
            target="_blank"
            >{{ 'footer.sharryland.who' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/it/press.html"
            target="_blank"
            >{{ 'footer.sharryland.press' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/it/lavora-con-noi.html"
            target="_blank"
            >{{ 'footer.sharryland.work' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            routerLink="{{ 'contacts' | routeTranslate }}"
            >{{ 'footer.contacts' | i18nextEager }}</a
          >
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel class="sharry-flat-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'footer.subtitle-2' | i18nextEager }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-panel-body">
          <a
            class="footer__body__column--links"
            routerLink="{{ 'faq' | routeTranslate }}"
            >{{ 'footer.faq' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            routerLink="{{ 'become-pro' | routeTranslate }}"
            >{{ 'footer.pro' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/it/embedding.html"
            target="_blank"
            >{{ 'footer.info.integrate' | i18nextEager }}</a
          >
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel class="sharry-flat-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'footer.subtitle-3' | i18nextEager }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-panel-body">
          <a
            class="footer__body__column--links"
            routerLink="{{ 'become-coordinator' | routeTranslate }}"
            >{{ 'footer.become-coordinator' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/it/sharrylander-doc.html"
            target="_blank"
            >{{ 'footer.partner.ref' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/pages/impact.html"
            target="_blank"
            >{{ 'footer.partner.paladin' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/it/comuni.html"
            target="_blank"
            >{{ 'footer.partner.municipality-friendly' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/it/comuni-amici.html"
            target="_blank"
            >{{ 'footer.partner.friends' | i18nextEager }}</a
          >
          <a
            class="footer__body__column--links"
            href="https://info.sharry.land/it/partnership.html"
            target="_blank"
            >{{ 'footer.partner.collaborations' | i18nextEager }}</a
          >
        </div>
      </mat-expansion-panel>

      <div class="footer__body__column">
        <h4>{{ 'footer.subtitle-4' | i18nextEager }}</h4>
        <div
          class="footer__body__column--buttons"
          style="gap: 0.5rem; padding-top: 0.5rem">
          <a
            class="sharry-medium buttons"
            href="https://play.google.com/store/apps/details?id=sharry.land.app"
            rel="noopener"
            target="_blank">
            <sharry-icon
              name="google-play-fill"
              svgClass="svg-icon"
              type="custom"></sharry-icon
            >&nbsp;Google Play
          </a>
          <a
            class="sharry-medium buttons"
            href="https://apps.apple.com/it/app/sharryland/id1477462434"
            rel="noopener"
            style="margin-bottom: 1rem"
            target="_blank">
            <sharry-icon
              name="apple-fill"
              svgClass="svg-icon"
              type="custom"></sharry-icon
            >&nbsp;App Store
          </a>
          <button
            class="sharry-small footer__body__language"
            (click)="onLanguageChange()">
            <sharry-icon name="globe"></sharry-icon>
            {{ language$ | async | language }}
          </button>
          <a
            class="footer__body__column--buttons-payments--stripe"
            href="https://www.stripe.com"
            target="_blank"
            >{{ 'footer.stripe-payments' | i18nextEager }}
            <img
              alt="stripe"
              height="20"
              src="https://media.sharry.land/app/images/payments/stripe.svg"
              width="50" />
          </a>
          <div class="footer__body__column--buttons-payments">
            <img
              alt="payment methods"
              height="20"
              src="https://media.sharry.land/app/images/payments/payments-group.png"
              width="140" />
          </div>
        </div>
      </div>
    </mat-accordion>
  </div>
  <div class="divider is-not-mobile"></div>
  <div class="footer__last-row">
    <!-- <p>&copy; {{year}} SharryLand srl Società Benefit - P.I. 05096140289</p> -->
    <a
      class="footer__body__column--links"
      routerLink="{{ 'what-is-sharryland' | routeTranslate }}"
      >&copy; SharryLand srl Società Benefit - P.I. 05096140289</a
    >
    <div class="footer__last-row--payments is-not-mobile">
      <a
        class="footer__last-row--payments--stripe"
        href="https://www.stripe.com"
        target="_blank"
        >{{ 'footer.stripe-payments' | i18nextEager }}
        <img
          alt="stripe"
          height="20"
          src="https://media.sharry.land/app/images/payments/stripe.svg"
          width="50" />
      </a>
      <div class="footer__last-row--payments--card">
        <img
          alt="payment methods"
          height="20"
          src="https://media.sharry.land/app/images/payments/payments-group.png"
          width="140" />
      </div>
    </div>
  </div>
</div>
